export default "__VITE_ASSET__N5W11$iz__"